import { useState } from 'react';

const useModalState = ({ deleteContentFromCampaign }) => {
  const [visibleModalDeleteContentRelation, setVisibleModalDeleteContentRelation] = useState(false);
  const [contentModal, setContentModal] = useState(null);
  const [deletingContentFromLibrary, setDeletingContentFromLibrary] = useState(false);
  const [visibleModalCleanContent, setVisibleModalCleanContent] = useState(false);
  const [visibleModalContent, setVisibleModalContent] = useState(false);
  const [visibleModalCloneNameContent, setVisibleModalCloneNameContent] = useState(false);
  const [contentToCloneName, setContentToCloneName] = useState(null);

  const showModalDeleteContentRelation = content => {
    setContentModal(content);
    setVisibleModalDeleteContentRelation(v => !v);
  };

  const showModalCleanContent = () => setVisibleModalCleanContent(v => !v);

  const showModalContent = content => {
    if (!content) return;
    setContentModal(content);
    setVisibleModalContent(true);
  };

  const cancelModalContent = () => {
    setContentModal(null);
    setVisibleModalContent(false);
  };

  const showModalCloneNameContent = content => {
    setContentToCloneName(content);
    setVisibleModalCloneNameContent(true);
  };

  const cancelModalCloneNameContent = () => {
    setContentToCloneName(null);
    setVisibleModalCloneNameContent(false);
  };

  const deleteContentOfListRelation = () => {
    setDeletingContentFromLibrary(true);
    deleteContentFromCampaign(contentModal.id);
    setVisibleModalDeleteContentRelation(v => !v);
  };

  return {
    // state
    visibleModalDeleteContentRelation,
    contentModal,
    deletingContentFromLibrary,
    setDeletingContentFromLibrary,
    visibleModalCleanContent,
    visibleModalContent,
    visibleModalCloneNameContent,
    contentToCloneName,
    // handlers
    showModalDeleteContentRelation,
    showModalCleanContent,
    showModalContent,
    cancelModalContent,
    showModalCloneNameContent,
    cancelModalCloneNameContent,
    deleteContentOfListRelation
  };
};

export default useModalState;
